import Config from "./config.json";

const systemSwapper = () => {
	const key = (process.env.REACT_APP_GPS_COMPANY || "").toLowerCase();
	const selected = Config[key];
	if (!selected) {
		throw new Error(
			`Unknown company "${key}". Options: ${Object.keys(Config).join(", ")}`
		);
	}
	return selected;
};

const System = systemSwapper();

export { System };
